module.exports = __webpack_public_path__ + "img/main-circle-4.eb7ad50d.png";